import "./styles/theme.css";
import React, { Suspense, useEffect } from "react";
import { connect } from "react-redux";
import { Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { routes } from "./routers";
import { AppLayout } from "./layouts";
import { applyTheme, getStoredTheme } from "./utils/helpers/theme";
import { fetchStoreSetting } from "./actions/storeAction";
import { cleanupModalArtifacts, scheduleModalCleanup } from "./utils/helpers/modalLifecycle";
import { applyStoreDocumentBrand } from "./utils/helpers/storeSetting";
import "./styles/dark-mode.css";

function App(props) {
  const { fetchStoreSetting, storeSetting, accessToken } = props;
  const location = useLocation();

  useEffect(() => {
    applyTheme(getStoredTheme());
    fetchStoreSetting();
  }, [accessToken, fetchStoreSetting]);

  useEffect(() => {
    applyStoreDocumentBrand(storeSetting);
  }, [storeSetting]);

  useEffect(() => {
    cleanupModalArtifacts({ force: true });

    const handleModalHidden = () => {
      scheduleModalCleanup();
    };

    document.addEventListener("hidden.bs.modal", handleModalHidden);

    return () => {
      document.removeEventListener("hidden.bs.modal", handleModalHidden);
    };
  }, []);

  useEffect(() => {
    const cleanupTimer = scheduleModalCleanup({ force: true, delay: 0 });
    return () => window.clearTimeout(cleanupTimer);
  }, [location.pathname]);

  const routeComponents = routes.map((item) => {
    return (
      <Route
        key={item.path}
        path={item.path}
        exact={item.exact}
        element={
          <AppLayout needAuthenticated={item.needAuthenticated} requiredPermissions={item.requiredPermissions}>
            <Toaster position="top-right" />
            <item.layout>
              <item.element />
            </item.layout>
          </AppLayout>
        }
      />
    );

  });

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>{routeComponents}</Routes>
    </Suspense>
  );
}

const mapStateToProps = (state) => ({
  storeSetting: state?.stores?.setting,
  accessToken: state?.auth?.login?.auth?.access_token,
});
export default connect(mapStateToProps, { fetchStoreSetting })(App);
